import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import DropDownMaterial from './DropDownMaterial';
import Footbar from './FootBar';
import { updateMaterial, refreshReferential } from '../../app/updateApp';
import MaterialEventContainer from './MaterialEventContainer';

const MaterialEvent = () => {
    const { t } = useTranslation();
    const materialState = useSelector(state => state.materials);

    useEffect(function () { refreshReferential().then(() => updateMaterial(materialState.selectedMaterial)); }, []);

    return <div className="module-page">
        <DropDownMaterial materials={materialState.list}/>
        <MaterialEventContainer />
        <Footbar />
    </div>;
};

export default MaterialEvent;

